const hasOseid = new URLSearchParams(window.location.search).has('oseid');

if(hasOseid || navigator.userAgent.toLowerCase().includes('bot')){
  document.cookie = 'geoRedirectDone=true; path=/';
}else if(!document.cookie.includes('geoRedirectDone=true')){
  fetch(window.location.href).then(response => {
    for (const [key, value] of response.headers.entries()) {
      if(key == 'server-timing'){
        if(value.indexOf('"IL"') > 0){
          if(document.location.origin != 'https://byneta.com' && document.referrer.indexOf('https://byneta.com') == -1){
            document.location.href = 'https://byneta.com';
          }else{
            document.cookie = 'geoRedirectDone=true; path=/';
          }
        }else{
          if(document.location.origin != 'https://bynetabeauty.com' && document.referrer.indexOf('https://bynetabeauty.com') == -1){
            document.location.href = 'https://bynetabeauty.com';
          }else{
            document.cookie = 'geoRedirectDone=true; path=/';
          }
        }
        break;
      }
    }
  });
}